
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news-and-events/feature",
      function () {
        return require("private-next-pages/news-and-events/feature.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news-and-events/feature"])
      });
    }
  